import React, {
  ButtonHTMLAttributes,
  DetailedHTMLProps,
  forwardRef,
  ReactNode,
} from 'react'

import 'app/components/common/button/button.scss'

type ButtonProps = {
  children: ReactNode
  className?: string
} & DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>

type Ref = HTMLButtonElement

const Button = forwardRef<Ref, ButtonProps>((props, ref) => {
  const { children, className = '', ...other } = props

  return (
    <button
      type="button"
      ref={ref}
      className={`button ${className}`}
      {...other}
    >
      {children}
    </button>
  )
})

Button.displayName = 'Button'

export default Button
